<template>
  <div class="tasksBox">
    <div class="title">
      <div class="titleIcon" @click="goBack">
        <i class="el-icon-arrow-left"></i>
      </div>
      <h2>任务</h2>
      <!-- <div class="goBackBox">
        <el-button type="primary" @click="goBack" class="goBackBtn">
          <i class="el-icon-back"></i>
        </el-button>
      </div> -->
    </div>
  </div>
</template>

<script>
export default {
  name: 'Tasks',
  components: {},
  props: {},
  data () {
    return {
    }
  },
  computed: {},
  watch: {},
  created () {},
  mounted () {},
  methods: {
    // 返回
    goBack() {
      this.$emit('goBack');
    },
  }
}
</script>

<style scoped lang="less">
.tasksBox {
  width: 100%;
  height: 100%;
  .title {
    line-height: 24px;
    margin: 16px 0 8px;
    height: 22px;
    display: flex;
    align-items: center;

    h2 {
      font-size: 18px;
      font-weight: 600;
    }
    .titleIcon {
      cursor: pointer;
      margin-right: 10px;
      i {
        color: #aaa;
        font-size: 24px;
      }
    }
  }
}
</style>
